export { type SurveysLogData, SurveysLogger, SurveysLogLevel } from './logger/surveys-logger'
export * from './map-api-component-type'

export const cn = (...classes: string[]) => {
  return classes.filter(Boolean).join(' ')
}
